module.exports = __webpack_public_path__ + "static/img/member_bg_card.fb8a0ad1.png";